


import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {

directives: {
TransferDom
},
components: {
Popup,
Swiper,
SwiperItem
},
props: {
isDetailPopShow: {
type: Boolean,
default: function() {
return false;
}
},
details: {
type: Object,
default: function() {
return {
imgList: [],
title: "",
address: "",
des: "",
mobile: "",
lat: "",
lng: "",
is_guide: false, //是否有导览
id: ""
};
}
}
},
data() {

return {
isShow: false, //弹窗是否展示


duration: "00:00", //音频总时长
audioCurTime: "00:00", //音频当前时间
playing: false, //音频播放中的状态
barWidth: 0, //已播放条的宽度值
dotLeft: 0 

};
},

computed: {},

watch: {
isDetailPopShow(newV, oldV) {
this.isShow = newV;
},
details(newV, oldV) {
let that = this;
if (this.details.audio) {
console.log("有语音");
that.audioEnded();
let audio = document.getElementById("dtAudio");
audio.src = that.details.audio;
audio.load();

audio.addEventListener("canplay", function() {
that.duration = that.commonFun.transTime(audio.duration);
});
} else {
console.log("没有语音");
}
},

isShow(newV, oldV) {
this.$emit("changeDetailShow", newV);
if (newV == false) {
console.log("关闭弹窗");
if (!document.getElementById("dtAudio").paused) {

document.getElementById("dtAudio").pause();
}
}
}
},

methods: {
jumpToMap() {
this.$router.push({
path: "/map",
name: "map",
query: { hid: this.details.id }
});
},
location() {
this.commonFun.openLocation(
this.details.title,
sessionStorage.getItem("lat"),
sessionStorage.getItem("lng"),
this.details.lat,
this.details.lng
);
},


progressBarBg(e) {
let audio = document.getElementById("dtAudio");
if (!audio.paused || audio.currentTime != 0) {

let pgsWidth = document.getElementsByClassName("progress-bar-bg")[0]
.offsetWidth;
let rate = e.offsetX / pgsWidth;
audio.currentTime = audio.duration * rate;
this.updateProgress(audio);
}
},



progressDot(e) {
let that = this;
let audio = document.getElementById("dtAudio");
let dot = document.getElementById("progressDot");
if (!audio.paused || audio.currentTime != 0) {
let oriLeft = dot.offsetLeft;
let mouseX = e.clientX;
let maxLeft = oriLeft; 
let maxRight =
document.getElementById("progressBarBg").offsetWidth - oriLeft; 


if (e.preventDefault) {
e.preventDefault();
} else {
e.returnValue = false;
}


if (e && e.stopPropagation) {
e.stopPropagation();
} else {
window.event.cancelBubble = true;
}


document.onmousemove = function(e) {
let length = e.clientX - mouseX;
if (length > maxRight) {
length = maxRight;
} else if (length < -maxLeft) {
length = -maxLeft;
}
let pgsWidth = document.getElementsByClassName("progress-bar-bg")[0]
.width;
let rate = (oriLeft + length) / pgsWidth;
audio.currentTime = audio.duration * rate;
that.updateProgress(audio);
};


document.onmouseup = function() {
document.onmousemove = null;
document.onmouseup = null;
};
}
},

audioPlay() {
let that = this;
let audio = document.getElementById("dtAudio");

audio.addEventListener(
"timeupdate",
function() {
that.updateProgress(audio);
},
false
);


audio.addEventListener(
"ended",
function() {
that.audioEnded();
},
false
);


if (audio.paused) {

audio.play();
that.playing = true;
} else {
audio.pause();
that.playing = false;
}
},

updateProgress(audio) {
let value = audio.currentTime / audio.duration;
this.barWidth = value * 100;
this.dotLeft = value * 100;
this.audioCurTime = this.commonFun.transTime(audio.currentTime);
this.duration = this.commonFun.transTime(audio.duration);
},

audioEnded() {
this.barWidth = 0;
this.dotLeft = 0;
this.playing = false;
this.audioCurTime = "00:00";
}
},

created() {},

mounted() {},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/components/detailPop.vue